import { configureStore } from "@reduxjs/toolkit";
import  kingdomOV3Slice from "./slicers/kingdomOV3Slice";



const store = configureStore({
    reducer: {
        kingdomOV3: kingdomOV3Slice
    }
});

export default store;